import request from '@/utils/request'

// 查收费科目收费标准
export const getRelationChargeCriterion = (data = {}) => request({ url: `/api/estate/v1/finance/getRelationChargeCriterion`, method: 'post', data })

// 初始化费用开始日期
export const chargeInitialIns = (data = {}) => request({ url: `/api/estate/v1/finance/chargeInitialIns`, method: 'post', data })

export const resetInitialDate = (data = {}) => request({ url: `/api/estate/v1/finance/resetInitialDate`, method: 'post', data })

// 收据
export const getReceiptImg = (params = {}) => request({ url: `/api/estate/v1/finance/getReceiptImg`, method: 'get', params, responseType: 'blob' })

export const getRefundReceiptImg = (params = {}) => request({ url: `/api/estate/v1/finance/getReceiptRefundImg`, method: 'get', params, responseType: 'blob' })

export const getFile = (params = {}) => request({ url: `/api/estate/v1/common/getFile`, method: 'get', params, responseType: 'blob' })

// 收费科目
export const chargeItemPage = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemPage`, method: 'post', data })

export const chargeItemCount = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemCount`, method: 'post', data })

export const chargeItemIns = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemIns`, method: 'post', data })

export const chargeItemUpd = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemUpd`, method: 'post', data })

export const chargeItemDel = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemDel`, method: 'post', data })

export const chargeItemDetail = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemDetail`, method: 'post', data })

export const chargeItemEnable = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemEnable`, method: 'post', data })

// 获取某个资产的单个科目余额
export const ownerPreChargeAccount = (data = {}) => request({ url: `/api/estate/v1/finance/ownerPreChargeAccount`, method: 'post', data })

// 收费套餐
export const chargeItemPackagePage = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemPackagePage`, method: 'post', data })

export const chargeItemPackageCount = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemPackageCount`, method: 'post', data })

export const chargeItemPackageIns = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemPackageIns`, method: 'post', data })

export const chargeItemPackageUpd = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemPackageUpd`, method: 'post', data })

export const chargeItemPackageDel = (data = {}) => request({ url: `/api/estate/v1/finance/chargeItemPackageDel`, method: 'post', data })

// 报销类别
export const reimbursementTypePage = (data = {}) => request({ url: `/api/estate/v1/workflow/reimbursementTypePage`, method: 'post', data })

export const reimbursementTypeCount = (data = {}) => request({ url: `/api/estate/v1/workflow/reimbursementTypeCount`, method: 'post', data })

export const reimbursementTypeIns = (data = {}) => request({ url: `/api/estate/v1/workflow/reimbursementTypeIns`, method: 'post', data })

export const reimbursementTypeUpd = (data = {}) => request({ url: `/api/estate/v1/workflow/reimbursementTypeUpd`, method: 'post', data })

export const reimbursementTypeDel = (data = {}) => request({ url: `/api/estate/v1/workflow/reimbursementTypeDel`, method: 'post', data })

export const reimbursementTypeDelBatch = (data = {}) => request({ url: `/api/estate/v1/workflow/reimbursementTypeDelBatch`, method: 'post', data })

export const materialDistribution = (data = {}) => request({ url: `/api/estate/v1/workflow/materialDistribution`, method: 'post', data })

// 收款方式
export const payTypePage = (data = {}) => request({ url: `/api/estate/v1/finance/payTypePage`, method: 'post', data })

export const payTypeCount = (data = {}) => request({ url: `/api/estate/v1/finance/payTypeCount`, method: 'post', data })

export const payTypeIns = (data = {}) => request({ url: `/api/estate/v1/finance/payTypeIns`, method: 'post', data })

export const payTypeUpd = (data = {}) => request({ url: `/api/estate/v1/finance/payTypeUpd`, method: 'post', data })

export const payTypeDel = (data = {}) => request({ url: `/api/estate/v1/finance/payTypeDel`, method: 'post', data })

export const payTypeDelBatch = (data = {}) => request({ url: `/api/estate/v1/finance/payTypeDelBatch`, method: 'post', data })

// 收费标准
export const chargeCriterionPage = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionPage`, method: 'post', data })

export const chargeCriterionCount = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionCount`, method: 'post', data })

export const chargeCriterionDetail = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionDetail`, method: 'post', data })

export const chargeCriterionIns = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionIns`, method: 'post', data })

export const chargeCriterionUpd = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionUpd`, method: 'post', data })

export const chargeCriterionCancel = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionCancel`, method: 'post', data })

export const chargeCriterionDel = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionDel`, method: 'post', data })

export const chargeCriterionDelBatch = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionDelBatch`, method: 'post', data })

export const chargeCriterionRelRoomEdit = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionRelRoomEdit`, method: 'post', data })

export const chargeCriterionRelRoomList = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionRelRoomList`, method: 'post', data })

export const chargeCriterionRelParkingSpaceList = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionRelParkingSpaceList`, method: 'post', data })

export const chargeCriterionRelSpaceEdit = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionRelSpaceEdit`, method: 'post', data })

export const chargeCriterionOperateRecordPage = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionOperateRecordPage`, method: 'post', data })

export const chargeCriterionOperateRecordCount = (data = {}) => request({ url: `/api/estate/v1/finance/chargeCriterionOperateRecordCount`, method: 'post', data })

// 业务办理-房屋缴纳
export const orderRoomCustomPage = (data = {}) => request({ url: `/api/estate/v1/finance/orderRoomCustomPage`, method: 'post', data })

export const calcOrderPenalty = (data = {}) => request({ url: `/api/estate/v1/finance/calcOrderPenalty`, method: 'post', data })

export const calcPenaltyAmount = (data = {}) => request({ url: `/api/estate/v1/commerce/calcPenaltyAmount`, method: 'post', data })

// 业务办理-车位未缴
export const orderCarSpaceCustomPage = (data = {}) => request({ url: `/api/estate/v1/finance/orderCarSpaceCustomPage`, method: 'post', data })

// 业务办理-房屋台账交割
export const deliveryRoomOrderPage = (data = {}) => request({ url: `/api/estate/v1/finance/deliveryRoomOrderPage`, method: 'post', data })

export const orderDeliveryRecordPage = (data = {}) => request({ url: `/api/estate/v1/finance/orderDeliveryRecordPage`, method: 'post', data })

export const orderDeliveryRecordCount = (data = {}) => request({ url: `/api/estate/v1/finance/orderDeliveryRecordCount`, method: 'post', data })

// 业务办理-车位台账交割
export const deliveryParkingSpaceOrderPage = (data = {}) => request({ url: `/api/estate/v1/finance/deliveryParkingSpaceOrderPage`, method: 'post', data })

// 报销审批
export const flowReimbursementDetailList = (data = {}) => request({ url: `/api/estate/v1/workflow/flowReimbursementDetailList`, method: 'post', data })

export const flowApplyReimbursementlInfo = (data = {}) => request({ url: `/api/estate/v1/workflow/flowApplyReimbursementlInfo`, method: 'post', data })

// 退款审批流程
export const refundAuditFlowDetail = (data = {}) => request({ url: `/finance/refundAuditFlowDetail`, method: 'post', data })

export const ownerPreChargeRecordList = (data = {}) => request({ url: `/api/estate/v1/finance/ownerPreChargeRecordList`, method: 'post', data })

export const ownerPreChargeRecordCount = (data = {}) => request({ url: `/api/estate/v1/finance/ownerPreChargeRecordCount`, method: 'post', data })

export const ownerPreChargeAccountList = (data = {}) => request({ url: `/api/estate/v1/finance/ownerPreChargeAccountList`, method: 'post', data })

export const ownerPreChargeAccountCount = (data = {}) => request({ url: `/api/estate/v1/finance/ownerPreChargeAccountCount`, method: 'post', data })

export const preChargeDiscountRule = (data = {}) => request({ url: `/api/estate/v1/finance/preChargeDiscountRule`, method: 'post', data })

// 优惠记录
export const orderPreferentialPage = (data = {}) => request({ url: `/api/estate/v1/finance/orderPreferentialPage`, method: 'post', data })

export const orderPreferentialCount = (data = {}) => request({ url: `/api/estate/v1/finance/orderPreferentialCount`, method: 'post', data })

export const orderPreferentialDetail = (data = {}) => request({ url: `/api/estate/v1/finance/orderPreferentialDetail`, method: 'post', data })

// 收款记录

export const paymentDetail = (data = {}) => request({ url: `/api/estate/v1/finance/paymentDetail`, method: 'post', data })

export const orderItemList = (data = {}) => request({ url: `/api/estate/v1/finance/orderItemList`, method: 'post', data })

export const getNotInvoiceGroup = (data = {}) => request({ url: `/api/estate/v1/invoice/getNotInvoiceGroup`, method: 'post', data })

export const householdGetInfoByIds = (data = {}) => request({ url: `/api/estate/v1/household/householdGetInfoByIds`, method: 'post', data })

export const invoiceOverview = (data = {}) => request({ url: `/api/estate/v1/invoice/invoiceOverview`, method: 'post', data })

export const submitBlueInvoice = (data = {}) => request({ url: `/api/estate/v1/invoice/submitBlueInvoice`, method: 'post', data })

// 退款记录
export const refundStatistic = (data = {}) => request({ url: `/api/estate/v1/workflow/refundStatistic`, method: 'post', data })

export const flowOrderRefundPage = (data = {}) => request({ url: `/api/estate/v1/workflow/flowOrderRefundPage`, method: 'post', data })

export const flowOrderRefundCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowOrderRefundCount`, method: 'post', data })

// 取消优惠
export const cancelPreferentialOrder = (data = {}) => request({ url: `/api/estate/v1/finance/cancelPreferentialOrder`, method: 'post', data })

export const cancelCyclePreferentialAudit = (data = {}) => request({ url: `/api/estate/v1/finance/cancelCyclePreferentialAudit`, method: 'post', data })

// 优惠申请

export const flowApplyPreInfo = (data = {}) => request({ url: `/api/estate/v1/workflow/flowApplyPreInfo`, method: 'post', data })

export const flowOrderPreferentialPage = (data = {}) => request({ url: `/api/estate/v1/workflow/flowOrderPreferentialPage`, method: 'post', data })

export const flowOrderPreferentialCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowOrderPreferentialCount`, method: 'post', data })

// 申请
export const submitFlowRefundApply = (data = {}) => request({ url: `/api/estate/v1/workflow/submitFlowRefundApply`, method: 'post', data })

// 开票
export const changeStatus = (data = {}) => request({ url: `/api/estate/v1/finance/changeStatus`, method: 'post', data })

// 房屋未缴
export const genCode = (data = {}) => request({ url: `/api/estate/v1/finance/genCode`, method: 'post', data, responseType: 'blob' })

export const buildingRoomUnPayDetailPage = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomUnPayDetailPage`, method: 'post', data })

export const buildingRoomUnPayDetailCount = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomUnPayDetailCount`, method: 'post', data })

export const buildingRoomUnPayCount = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomUnPayCount`, method: 'post', data })

export const buildingRoomUnPayPage = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomUnPayPage`, method: 'post', data })

export const generateBillReminder = (data = {}) => request({ url: `/api/estate/v1/finance/generateBillReminder`, method: 'post', data })

export const generateBillReminderBatch = (data = {}) => request({ url: `/api/estate/v1/finance/generateBillReminderBatch`, method: 'post', data })

export const wechatChargePay = (data = {}) => request({ url: `/api/estate/v1/finance/wechatChargePay`, method: 'post', data })

export const smsChargePay = (data = {}) => request({ url: `/api/estate/v1/finance/smsChargePay`, method: 'post', data })

export const phoneChargePay = (data = {}) => request({ url: `/api/estate/v1/finance/phoneChargePay`, method: 'post', data })

export const smsChargePayBatch = (data = {}) => request({ url: `/api/estate/v1/finance/smsChargePayBatch`, method: 'post', data })

export const phoneChargePayBatch = (data = {}) => request({ url: `/api/estate/v1/finance/phoneChargePayBatch`, method: 'post', data })

export const wechatChargePayBatch = (data = {}) => request({ url: `/api/estate/v1/finance/wechatChargePayBatch`, method: 'post', data })

// 车位未缴
export const orderCarSpaceCustomDetail = (data = {}) => request({ url: `/api/estate/v1/finance/orderCarSpaceCustomDetail`, method: 'post', data })

export const parkingSpaceUnPayDetailPage = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpaceUnPayDetailPage`, method: 'post', data })

export const parkingSpaceUnPayCount = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpaceUnPayCount`, method: 'post', data })

export const parkingSpaceUnPayDetailCount = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpaceUnPayDetailCount`, method: 'post', data })

export const parkingSpaceUnPayPage = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpaceUnPayPage`, method: 'post', data })

export const unPayDetailPage = (data = {}) => request({ url: `/api/estate/v1/finance/unPayDetailPage`, method: 'post', data })

export const unPayDetailCount = (data = {}) => request({ url: `/api/estate/v1/finance/unPayDetailCount`, method: 'post', data })

export const generateParkingSpaceBillReminder = (data = {}) => request({ url: `/api/estate/v1/finance/generateParkingSpaceBillReminder`, method: 'post', data })

export const generateParkingSpaceBillReminderBatch = (data = {}) => request({ url: `/api/estate/v1/finance/generateParkingSpaceBillReminderBatch`, method: 'post', data })

// 退款审批
export const flowReimbursementDetailCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowReimbursementDetailCount`, method: 'post', data })

// 物资审批
export const flowMaterialDetailCount = (data = {}) => request({ url: `/api/estate/v1/workflow/flowMaterialDetailCount`, method: 'post', data })

// 财务报表

export const financePreChargeReport = (data = {}) => request({ url: `/api/estate/v1/finance/financePreChargeReport`, method: 'post', data })

export const financeDepositReport = (data = {}) => request({ url: `/api/estate/v1/finance/financeDepositReport`, method: 'post', data })

// 财务报表-年度报表
export const financeAnnualReportAmount = (data = {}) => request({ url: `/api/estate/v1/finance/financeAnnualReportAmount`, method: 'post', data })

export const financeAnnualReportBuildingCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeAnnualReportBuildingCount`, method: 'post', data })

export const financeAnnualReportBuildingPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeAnnualReportBuildingPage`, method: 'post', data })

export const financeAnnualReportCommunityCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeAnnualReportCommunityCount`, method: 'post', data })

export const financeAnnualReportCommunityPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeAnnualReportCommunityPage`, method: 'post', data })

export const financeAnnualReportItemPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeAnnualReportItemPage`, method: 'post', data })

export const financeAnnualReportParkingPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeAnnualReportParkingPage`, method: 'post', data })

export const financeAnnualReportParkingCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeAnnualReportParkingCount`, method: 'post', data })

// 财务报表-应收报表
export const financeReceivableBuildingReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableBuildingReportCount`, method: 'post', data })

export const financeReceivableBuildingReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableBuildingReportPage`, method: 'post', data })

export const financeReceivableItemReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableItemReportCount`, method: 'post', data })

export const financeReceivableItemReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableItemReportPage`, method: 'post', data })

export const financeReceivableCommunityReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableCommunityReportCount`, method: 'post', data })

export const financeReceivableCommunityReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableCommunityReportPage`, method: 'post', data })

export const financeReceivableAmountReport = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableAmountReport`, method: 'post', data })

export const receivableOrderAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receivableOrderAmountPage`, method: 'post', data })

export const receivableOrderAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receivableOrderAmountCount`, method: 'post', data })

export const receivableUnpaidAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receivableUnpaidAmountPage`, method: 'post', data })

export const receivableUnpaidAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receivableUnpaidAmountCount`, method: 'post', data })

export const receivableRefundAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receivableRefundAmountPage`, method: 'post', data })

export const receivableRefundAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receivableRefundAmountCount`, method: 'post', data })

export const receivablePreferentialAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receivablePreferentialAmountPage`, method: 'post', data })

export const receivablePreferentialAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receivablePreferentialAmountCount`, method: 'post', data })

export const receivableRealAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receivableRealAmountPage`, method: 'post', data })

export const receivableRealAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receivableRealAmountCount`, method: 'post', data })

export const financeReceivableParkingReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableParkingReportPage`, method: 'post', data })

export const financeReceivableParkingReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableParkingReportCount`, method: 'post', data })

// 应收-按自然月统计
export const financeReceivableMonthParkingReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableMonthParkingReportPage`, method: 'post', data })

export const financeReceivableMonthParkingReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableMonthParkingReportCount`, method: 'post', data })

export const financeReceivableMonthItemReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableMonthItemReportPage`, method: 'post', data })

export const financeReceivableMonthItemReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableMonthItemReportCount`, method: 'post', data })

export const financeReceivableMonthCommunityReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableMonthCommunityReportPage`, method: 'post', data })

export const financeReceivableMonthCommunityReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableMonthCommunityReportCount`, method: 'post', data })

export const financeReceivableMonthBuildingReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableMonthBuildingReportPage`, method: 'post', data })

export const financeReceivableMonthBuildingReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableMonthBuildingReportCount`, method: 'post', data })

export const financeReceivableMonthAmountReport = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableMonthAmountReport`, method: 'post', data })

export const financeReceivableMonthReportByStaff = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableMonthReportByStaff`, method: 'post', data })

export const financeReceivableReportByStaff = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceivableReportByStaff`, method: 'post', data })

export const receivableMonthOrderAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receivableMonthOrderAmountPage`, method: 'post', data })

export const receivableMonthOrderAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receivableMonthOrderAmountCount`, method: 'post', data })

export const receivableMonthRealAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receivableMonthRealAmountCount`, method: 'post', data })

export const receivableMonthRealAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receivableMonthRealAmountPage`, method: 'post', data })

export const receivableMonthPreferentialAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receivableMonthPreferentialAmountPage`, method: 'post', data })

export const receivableMonthPreferentialAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receivableMonthPreferentialAmountCount`, method: 'post', data })

export const receivableMonthRefundAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receivableMonthRefundAmountPage`, method: 'post', data })

export const receivableMonthRefundAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receivableMonthRefundAmountCount`, method: 'post', data })

export const receivableMonthUnpaidAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receivableMonthUnpaidAmountPage`, method: 'post', data })

export const receivableMonthUnpaidAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receivableMonthUnpaidAmountCount`, method: 'post', data })

// 财务报表-收款报表
export const financeChargeAmountReport = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeAmountReport`, method: 'post', data })

export const financeChargeBuildingReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeBuildingReportCount`, method: 'post', data })

export const financeChargeBuildingReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeBuildingReportPage`, method: 'post', data })

export const financeChargeCommunityReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeCommunityReportCount`, method: 'post', data })

export const financeChargeCommunityReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeCommunityReportPage`, method: 'post', data })

export const financeChargeItemReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeItemReportCount`, method: 'post', data })

export const financeChargeItemReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeItemReportPage`, method: 'post', data })

export const financeChargePayWayReport = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargePayWayReport`, method: 'post', data })

export const financeChargeRefundWayReport = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeRefundWayReport`, method: 'post', data })

export const financeChargeReportAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeReportAmountPage`, method: 'post', data })

export const financeChargeReportAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeReportAmountCount`, method: 'post', data })

export const financeChargeReportRealAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeReportRealAmountPage`, method: 'post', data })

export const financeChargeReportRealAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeReportRealAmountCount`, method: 'post', data })

export const financeChargeReportReturnAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeReportReturnAmountPage`, method: 'post', data })

export const financeChargeReportReturnAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeChargeReportReturnAmountCount`, method: 'post', data })

export const receiveOrderAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receiveOrderAmountPage`, method: 'post', data })

export const receiveOrderAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receiveOrderAmountCount`, method: 'post', data })

// 按收款明细统计

// 按自然月统计
export const financeReceiveMonthReport = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveMonthReport`, method: 'post', data })

export const financeReceiveMonthReportByYear = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveMonthReportByYear`, method: 'post', data })

export const financeReceiveMonthReportByStaff = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveMonthReportByStaff`, method: 'post', data })

export const financeReceiveMonthReportByParking = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveMonthReportByParking`, method: 'post', data })

export const financeReceiveMonthReportByItem = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveMonthReportByItem`, method: 'post', data })

export const financeReceiveMonthReportByCommunity = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveMonthReportByCommunity`, method: 'post', data })

export const financeReceiveMonthReportByBuilding = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveMonthReportByBuilding`, method: 'post', data })

export const receiveMonthOrderAmountPage = (data = {}) => request({ url: `/api/estate/v1/finance/receiveMonthOrderAmountPage`, method: 'post', data })

export const receiveMonthOrderAmountCount = (data = {}) => request({ url: `/api/estate/v1/finance/receiveMonthOrderAmountCount`, method: 'post', data })

// 财务报表-欠费报表
export const financeUnpaidAmountReport = (data = {}) => request({ url: `/api/estate/v1/finance/financeUnpaidAmountReport`, method: 'post', data })

export const financeItemReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeItemReportCount`, method: 'post', data })

export const financeUnpaidBuildingReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeUnpaidBuildingReportCount`, method: 'post', data })

export const financeUnpaidBuildingReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeUnpaidBuildingReportPage`, method: 'post', data })

export const financeUnpaidCommunityReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeUnpaidCommunityReportCount`, method: 'post', data })

export const financeUnpaidCommunityReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeUnpaidCommunityReportPage`, method: 'post', data })

export const financeUnpaidCurrentYearItemReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeUnpaidCurrentYearItemReportPage`, method: 'post', data })

export const financeUnpaidYearReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeUnpaidYearReportPage`, method: 'post', data })

export const financeUnpaidIsHistoryItemReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeUnpaidIsHistoryItemReportPage`, method: 'post', data })

export const unpaidHistoryPayPage = (data = {}) => request({ url: `/api/estate/v1/finance/unpaidHistoryPayPage`, method: 'post', data })

export const unpaidHistoryPayCount = (data = {}) => request({ url: `/api/estate/v1/finance/unpaidHistoryPayCount`, method: 'post', data })

export const unpaidHistoryPage = (data = {}) => request({ url: `/api/estate/v1/finance/unpaidHistoryPage`, method: 'post', data })

export const unpaidHistoryCount = (data = {}) => request({ url: `/api/estate/v1/finance/unpaidHistoryCount`, method: 'post', data })

export const unpaidCurrentYearPage = (data = {}) => request({ url: `/api/estate/v1/finance/unpaidCurrentYearPage`, method: 'post', data })

export const unpaidCurrentYearCount = (data = {}) => request({ url: `/api/estate/v1/finance/unpaidCurrentYearCount`, method: 'post', data })

export const financeUnpaidParkingReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/financeUnpaidParkingReportPage`, method: 'post', data })

export const financeUnpaidParkingReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/financeUnpaidParkingReportCount`, method: 'post', data })

// 财务报表-预存预缴报表
export const preChargePage = (data = {}) => request({ url: `/api/estate/v1/finance/preChargePage`, method: 'post', data })

export const preChargeCount = (data = {}) => request({ url: `/api/estate/v1/finance/preChargeCount`, method: 'post', data })

// 财务报表-收款情况
export const paySituationParkingPage = (data = {}) => request({ url: `/api/estate/v1/finance/paySituationParkingPage`, method: 'post', data })

export const paySituationParkingCount = (data = {}) => request({ url: `/api/estate/v1/finance/paySituationParkingCount`, method: 'post', data })

export const paySituationBuildingPage = (data = {}) => request({ url: `/api/estate/v1/finance/paySituationBuildingPage`, method: 'post', data })

export const paySituationBuildingCount = (data = {}) => request({ url: `/api/estate/v1/finance/paySituationBuildingCount`, method: 'post', data })

export const paySituationCommunityPage = (data = {}) => request({ url: `/api/estate/v1/finance/paySituationCommunityPage`, method: 'post', data })

export const paySituationReportCommunityCount = (data = {}) => request({ url: `/api/estate/v1/finance/paySituationReportCommunityCount`, method: 'post', data })

export const paymentStatistic = (data = {}) => request({ url: `/api/estate/v1/finance/paymentStatistic`, method: 'post', data })

// 财务报表-车场报表
export const parkingLotFees = (data = {}) => request({ url: `/api/estate/v1/finance/parkingLotFees`, method: 'post', data })

export const parkingLotChargeReports = (data = {}) => request({ url: `/api/estate/v1/finance/parkingLotChargeReports`, method: 'post', data })

export const parkingLotChargeCount = (data = {}) => request({ url: `/api/estate/v1/finance/parkingLotChargeCount`, method: 'post', data })

// 财务报表-负债报表
export const liabilitiesPrePayAmountReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesPrePayAmountReportPage`, method: 'post', data })

export const liabilitiesPrePayAmountReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesPrePayAmountReportCount`, method: 'post', data })

export const liabilitiesPreChargeAmountReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesPreChargeAmountReportPage`, method: 'post', data })

export const liabilitiesPreChargeAmountReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesPreChargeAmountReportCount`, method: 'post', data })

export const liabilitiesDepositAmountReportPage = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesDepositAmountReportPage`, method: 'post', data })

export const liabilitiesDepositAmountReportCount = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesDepositAmountReportCount`, method: 'post', data })

export const liabilitiesAmountReport = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesAmountReport`, method: 'post', data })

// 财务报表-收款报表
export const financeReceiveReport = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveReport`, method: 'post', data })

export const financeReceiveReportByYear = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveReportByYear`, method: 'post', data })

export const financeReceiveReportByStaff = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveReportByStaff`, method: 'post', data })

export const financeReceiveReportByPayWay = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveReportByPayWay`, method: 'post', data })

export const financeReceiveReportByParking = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveReportByParking`, method: 'post', data })

export const financeReceiveReportByItem = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveReportByItem`, method: 'post', data })

export const financeReceiveReportByCommunity = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveReportByCommunity`, method: 'post', data })

export const financeReceiveReportByBuilding = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveReportByBuilding`, method: 'post', data })

export const financeReceiveAssertByCommunity = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveAssertByCommunity`, method: 'post', data })

export const financeReceiveAssertByBuilding = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveAssertByBuilding`, method: 'post', data })

export const financeReceiveAssertByParking = (data = {}) => request({ url: `/api/estate/v1/finance/financeReceiveAssertByParking`, method: 'post', data })

//通知规则
export const moneyRulePage = (data = {}) => request({ url: `/api/estate/v1/charge/moneyRulePage`, method: 'post', data })

export const moneyRuleCount = (data = {}) => request({ url: `/api/estate/v1/charge/moneyRuleCount`, method: 'post', data })

export const moneyRuleIns = (data = {}) => request({ url: `/api/estate/v1/charge/moneyRuleIns`, method: 'post', data })

export const remindMoneyStatusUpd = (data = {}) => request({ url: `/api/estate/v1/charge/remindMoneyStatusUpd`, method: 'post', data })

export const moneyRuleUpd = (data = {}) => request({ url: `/api/estate/v1/charge/moneyRuleUpd`, method: 'post', data })

export const moneyRuleDel = (data = {}) => request({ url: `/api/estate/v1/charge/moneyRuleDel`, method: 'post', data })

export const moneyRuleDetail = (data = {}) => request({ url: `/api/estate/v1/charge/moneyRuleDetail`, method: 'post', data })

//通知记录
export const roomDetailPage = (data = {}) => request({ url: `/api/estate/v1/charge/roomDetailPage`, method: 'post', data })

export const roomDetailCount = (data = {}) => request({ url: `/api/estate/v1/charge/roomDetailCount`, method: 'post', data })

// 开发商费用
export const developerPayRecordPage = (data = {}) => request({ url: `/api/estate/v1/finance/developerPayRecordPage`, method: 'post', data })

export const developerPayRecordCount = (data = {}) => request({ url: `/api/estate/v1/finance/developerPayRecordCount`, method: 'post', data })

export const developerPayRecordIns = (data = {}) => request({ url: `/api/estate/v1/finance/developerPayRecordIns`, method: 'post', data })

export const developerPayRecordDel = (data = {}) => request({ url: `/api/estate/v1/finance/developerPayRecordDel`, method: 'post', data })

// 收款记录-房屋
export const buildingRoomPaymentPage = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomPaymentPage`, method: 'post', data })

export const buildingRoomPaymentCount = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomPaymentCount`, method: 'post', data })

// 收款记录-车位
export const parkingSpacePaymentPage = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpacePaymentPage`, method: 'post', data })

export const parkingSpacePaymentCount = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpacePaymentCount`, method: 'post', data })

// 未缴账单-开发商费用
export const developerBalancePage = (data = {}) => request({ url: `/api/estate/v1/finance/developerBalancePage`, method: 'post', data })

export const developerBalanceCount = (data = {}) => request({ url: `/api/estate/v1/finance/developerBalanceCount`, method: 'post', data })

//未缴账单-开发商费用-费用明细
export const developerPayItemList = (data = {}) => request({ url: `/api/estate/v1/finance/developerPayItemList`, method: 'post', data })

//(定制)excel导入导出记录列表
export const excelRecordPage = (data = {}) => request({ url: `/api/estate/v1/oa/excelRecordPage`, method: 'post', data })

export const excelRecordCount = (data = {}) => request({ url: `/api/estate/v1/oa/excelRecordCount`, method: 'post', data })

// 取消优惠
export const revokePreferentialOrder = (data = {}) => request({ url: `/api/estate/v1/finance/revokePreferentialOrder`, method: 'post', data })

// 收款记录
export const paymentRecordPage = (data = {}) => request({ url: `/api/estate/v1/finance/paymentRecordPage`, method: 'post', data })

export const paymentRecordCount = (data = {}) => request({ url: `/api/estate/v1/finance/paymentRecordCount`, method: 'post', data })

export const setFinishCheck = (data = {}) => request({ url: `/api/estate/v1/finance/setFinishCheck`, method: 'post', data })

export const cancelFinishCheck = (data = {}) => request({ url: `/api/estate/v1/finance/cancelFinishCheck`, method: 'post', data })

// 作废
export const voidCheckPayment = (data = {}) => request({ url: `/api/estate/v1/finance/voidCheckPayment`, method: 'post', data })

// 缴费明细
export const paymentDetailsInfoPage = (data = {}) => request({ url: `/api/estate/v1/finance/paymentDetailsInfoPage`, method: 'post', data })

export const paymentDetailsInfoCount = (data = {}) => request({ url: `/api/estate/v1/finance/paymentDetailsInfoCount`, method: 'post', data })

export const paymentPage = (data = {}) => request({ url: `/api/estate/v1/finance/paymentPage`, method: 'post', data })

export const paymentCount = (data = {}) => request({ url: `/api/estate/v1/finance/paymentCount`, method: 'post', data })

export const paymentDetailsInfoStatistic = (data = {}) => request({ url: `/api/estate/v1/finance/paymentDetailsInfoStatistic`, method: 'post', data })

// 收费标准
export const chargeParkingSpaceRelPage = (data = {}) => request({ url: `/api/estate/v1/finance/chargeParkingSpaceRelPage`, method: 'post', data })

export const chargeParkingSpaceRelCount = (data = {}) => request({ url: `/api/estate/v1/finance/chargeParkingSpaceRelCount`, method: 'post', data })

export const chargeRoomRelPage = (data = {}) => request({ url: `/api/estate/v1/finance/chargeRoomRelPage`, method: 'post', data })

export const chargeRoomRelCount = (data = {}) => request({ url: `/api/estate/v1/finance/chargeRoomRelCount`, method: 'post', data })

export const chargeParkingCarRelPage = (data = {}) => request({ url: `/api/estate/v1/finance/chargeParkingCarRelPage`, method: 'post', data })

export const chargeParkingCarRelCount = (data = {}) => request({ url: `/api/estate/v1/finance/chargeParkingCarRelCount`, method: 'post', data })

export const chargeParkingSpaceRelIns = (data = {}) => request({ url: `/api/estate/v1/finance/chargeParkingSpaceRelIns`, method: 'post', data })

export const chargeRoomRelIns = (data = {}) => request({ url: `/api/estate/v1/finance/chargeRoomRelIns`, method: 'post', data })

export const chargeParkingCarRelIns = (data = {}) => request({ url: `/api/estate/v1/finance/chargeParkingCarRelIns`, method: 'post', data })

export const chargeRoomRelDel = (data = {}) => request({ url: `/api/estate/v1/finance/chargeRoomRelDel`, method: 'post', data })

export const chargeParkingSpaceRelDel = (data = {}) => request({ url: `/api/estate/v1/finance/chargeParkingSpaceRelDel`, method: 'post', data })

export const chargeParkingCarRelDel = (data = {}) => request({ url: `/api/estate/v1/finance/chargeParkingCarRelDel`, method: 'post', data })

//财务采购预算
export const materialBudgetPage = (data = {}) => request({ url: `/api/estate/v1/oa/materialBudgetPage`, method: 'post', data })

export const materialBudgetCount = (data = {}) => request({ url: `/api/estate/v1/oa/materialBudgetCount`, method: 'post', data })

export const materialBudgetIns = (data = {}) => request({ url: `/api/estate/v1/oa/materialBudgetIns`, method: 'post', data })

export const materialBudgetDetail = (data = {}) => request({ url: `/api/estate/v1/oa/materialBudgetDetail`, method: 'post', data })

export const materialBudgetUpd = (data = {}) => request({ url: `/api/estate/v1/oa/materialBudgetUpd`, method: 'post', data })

// 撤销交割
export const rollBackDeliveryOrder = (data = {}) => request({ url: `/api/estate/v1/finance/rollBackDeliveryOrder`, method: 'post', data })

// 优惠政策
export const discountRulePage = (data = {}) => request({ url: `/api/estate/v1/finance/discountRulePage`, method: 'post', data })

export const discountRuleCount = (data = {}) => request({ url: `/api/estate/v1/finance/discountRuleCount`, method: 'post', data })

export const discountRuleIns = (data = {}) => request({ url: `/api/estate/v1/finance/discountRuleIns`, method: 'post', data })

export const discountRuleUpd = (data = {}) => request({ url: `/api/estate/v1/finance/discountRuleUpd`, method: 'post', data })

export const discountRuleDel = (data = {}) => request({ url: `/api/estate/v1/finance/discountRuleDel`, method: 'post', data })

// 全部账单
export const fullOrderStatic = (data = {}) => request({ url: `/api/estate/v1/finance/fullOrderStatic`, method: 'post', data })

export const buildingRoomFullOrderList = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomFullOrderList`, method: 'post', data })

export const parkingCarFullOrderList = (data = {}) => request({ url: `/api/estate/v1/finance/parkingCarFullOrderList`, method: 'post', data })

export const parkingSpaceFullOrderList = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpaceFullOrderList`, method: 'post', data })

export const fullOrderCount = (data = {}) => request({ url: `/api/estate/v1/finance/fullOrderCount`, method: 'post', data })

// 待退押金
export const buildingRoomDepositOrderList = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomDepositOrderList`, method: 'post', data })

export const parkingSpaceDepositOrderList = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpaceDepositOrderList`, method: 'post', data })

export const parkingCarDepositOrderList = (data = {}) => request({ url: `/api/estate/v1/finance/parkingCarDepositOrderList`, method: 'post', data })

export const depositOrderCount = (data = {}) => request({ url: `/api/estate/v1/finance/depositOrderCount`, method: 'post', data })

export const buildingRoomDepositOrderPage = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomDepositOrderPage`, method: 'post', data })

export const buildingRoomDepositOrderCount = (data = {}) => request({ url: `/api/estate/v1/finance/buildingRoomDepositOrderCount`, method: 'post', data })

export const parkingSpaceDepositOrderPage = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpaceDepositOrderPage`, method: 'post', data })

export const parkingSpaceDepositOrderCount = (data = {}) => request({ url: `/api/estate/v1/finance/parkingSpaceDepositOrderCount`, method: 'post', data })

// 挂账
export const orderPostponeSet = (data = {}) => request({ url: `/api/estate/v1/finance/orderPostponeSet`, method: 'post', data })

export const orderPostponeList = (data = {}) => request({ url: `/api/estate/v1/finance/orderPostponeList`, method: 'post', data })

export const orderPostponeCount = (data = {}) => request({ url: `/api/estate/v1/finance/orderPostponeCount`, method: 'post', data })

// 业主支付配置
export const ownerPayConfigPage = (data = {}) => request({ url: `/api/estate/v1/finance/ownerPayConfigPage`, method: 'post', data })

export const ownerPayConfigCount = (data = {}) => request({ url: `/api/estate/v1/finance/ownerPayConfigCount`, method: 'post', data })

export const ownerPayConfigIns = (data = {}) => request({ url: `/api/estate/v1/finance/ownerPayConfigIns`, method: 'post', data })

export const ownerPayConfigUpd = (data = {}) => request({ url: `/api/estate/v1/finance/ownerPayConfigUpd`, method: 'post', data })

export const ownerPayConfigDel = (data = {}) => request({ url: `/api/estate/v1/finance/ownerPayConfigDel`, method: 'post', data })

// 违约金配置
export const penaltyRuleIns = (data = {}) => request({ url: `/api/estate/v1/finance/penaltyRuleIns`, method: 'post', data })

export const penaltyRuleUpd = (data = {}) => request({ url: `/api/estate/v1/finance/penaltyRuleUpd`, method: 'post', data })

export const penaltyRulePage = (data = {}) => request({ url: `/api/estate/v1/finance/penaltyRulePage`, method: 'post', data })

export const penaltyRuleCount = (data = {}) => request({ url: `/api/estate/v1/finance/penaltyRuleCount`, method: 'post', data })

export const penaltyRuleDel = (data = {}) => request({ url: `/api/estate/v1/finance/penaltyRuleDel`, method: 'post', data })

// 账户余额
export const assetAccountBalancePage = (data = {}) => request({ url: `/api/estate/v1/finance/assetAccountBalancePage`, method: 'post', data })

export const assetAccountBalanceCount = (data = {}) => request({ url: `/api/estate/v1/finance/assetAccountBalanceCount`, method: 'post', data })

export const assetAccountBalance = (data = {}) => request({ url: `/api/estate/v1/finance/assetAccountBalance`, method: 'post', data })

export const assetAccountRecordPage = (data = {}) => request({ url: `/api/estate/v1/finance/assetAccountRecordPage`, method: 'post', data })

export const assetAccountRecordCount = (data = {}) => request({ url: `/api/estate/v1/finance/assetAccountRecordCount`, method: 'post', data })

//财务作废申请
export const submitFlowFinanceCancelApply = (data = {}) => request({ url: `/api/estate/v1/workflow/submitFlowFinanceCancelApply`, method: 'post', data })

//根据房屋ID获取住户的欠费信息
export const getHouseholdUnPayBuildingRoomDetailPage = (data = {}) => request({ url: `/api/estate/v1/household/getHouseholdUnPayBuildingRoomDetailPage`, method: 'post', data })

export const getHouseholdUnPayBuildingRoomDetailCount = (data = {}) => request({ url: `/api/estate/v1/household/getHouseholdUnPayBuildingRoomDetailCount`, method: 'post', data })

//根据车位ID获取住户的欠费信息
export const getHouseholdUnPayParkingSpaceDetailPage = (data = {}) => request({ url: `/api/estate/v1/household/getHouseholdUnPayParkingSpaceDetailPage`, method: 'post', data })

export const getHouseholdUnPayParkingSpaceDetailCount = (data = {}) => request({ url: `/api/estate/v1/household/getHouseholdUnPayParkingSpaceDetailCount`, method: 'post', data })

// 财务报表-负债报表-按项目统计
export const liabilitiesAmountGroupCommunityIdReport = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesAmountGroupCommunityIdReport`, method: 'post', data })

// 财务报表-负债报表-押金-详情
export const liabilitiesDepositAmountReportDetailPage = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesDepositAmountReportDetailPage`, method: 'post', data })

export const liabilitiesDepositAmountReportDetailCount = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesDepositAmountReportDetailCount`, method: 'post', data })

//财务报表-负债报表-预存-详情
export const liabilitiesPreChargeAmountReportDetailPage = (data = {}) => request({ url: `/api/estate/v1/finance/liabilitiesPreChargeAmountReportDetailPage`, method: 'post', data })

export const liabilitiesPreChargeAmountReportDetailCount = (data = {}) =>
  request({ url: `/api/estate/v1/finance/liabilitiesPreChargeAmountReportDetailCount`, method: 'post', data })

// 财务报表-负债报表-账户-详情
export const liabilitiesPreChargeAmountAccountDetailPage = (data = {}) =>
  request({ url: `/api/estate/v1/finance/liabilitiesPreChargeAmountAccountDetailPage`, method: 'post', data })

export const liabilitiesPreChargeAmountAccountDetailCount = (data = {}) =>
  request({ url: `/api/estate/v1/finance/liabilitiesPreChargeAmountAccountDetailCount`, method: 'post', data })

// 业主支付月份配置
export const ownerPayConfig = (data = {}) => request({ url: `/api/estate/v1/ownerFinance/ownerPayConfig`, method: 'post', data })
